/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

/**
 * Compare 2 responses object from the upload interactions.
 * To prevent reading the full file, the comparison is made only
 * the response data (name, mime type) and the file size only.
 *
 * @param {Object} responseValue1
 * @param {Object} responseValue2
 * @returns {boolean} true if they are equal, false if not
 */
export function compareResponseValues(responseValue1, responseValue2) {
    return (
        responseValue1 === responseValue2 ||
        (typeof responseValue1 === 'object' &&
            responseValue1 !== null &&
            typeof responseValue2 === 'object' &&
            responseValue2 !== null &&
            responseValue1.mime === responseValue2.mime &&
            responseValue1.name === responseValue2.name &&
            responseValue1.data === responseValue2.data)
    );
}
